export enum ResultType {
    Success = 'Success',
    Error = 'Error',
    Partial = 'PartialFail'
}

/**
 * @class API error data object.
 */
export class RESTAPIError extends Error {
    readonly HTTPStatus: number
    readonly JSONObject: Nullable<object>
    readonly errorMessage: string
    readonly errorCode: Nullable<string>
    readonly resultType: ResultType = ResultType.Error
    readonly name: string // Overridden Error name property;

    /**
     * Constructor.
     *
     * @param HTTPStatus HTTP status code.
     * @param JSONObject JSON object from the response.
     * @param errorMessage Error message.
     * @param errorCode Error code.
     * @param resultType Result type.
     */
    constructor(
        HTTPStatus: number,
        JSONObject: Nullable<object>,
        errorMessage: string,
        errorCode: Nullable<string>,
        resultType?: ResultType
    ) {
        super(errorMessage)
        // TypeScript compiles this file with target es3, which breaks the
        // prototype chain when extending native Error (instances end up with
        // Error.prototype, not RESTAPIError.prototype). Restore it explicitly
        // so `error instanceof RESTAPIError` works.
        Object.setPrototypeOf(this, RESTAPIError.prototype)
        this.HTTPStatus = HTTPStatus
        this.JSONObject = JSONObject
        this.errorMessage = errorMessage
        this.errorCode = errorCode
        this.resultType = resultType ?? ResultType.Error
        this.name = 'RESTAPIError'
    }
}
